export const ALPHANUMERIC_AND_SPECIAL_REGEX = /[^0-9a-z_@.#+\-& àâçéèêïôûùü]+/gi;
export const ALPHANUMERIC_REGEX = /[^0-9a-z àâçéèêïôûùü]+/gi;
export const ALPHABETIC_REGEX = /[^a-z àâçéèêïôûùü]+/gi;
export const NUMERIC_REGEX = /\D+/g;

export function sanitizeAlphaNumericAndSpecial(text: string): string {
  return text.replace(ALPHANUMERIC_AND_SPECIAL_REGEX, '');
}

export function sanitizeAlphaNumeric(text: string): string {
  return text.replace(ALPHANUMERIC_REGEX, '');
}

export function sanitizeAlphabetic(text: string): string {
  return text.replace(ALPHABETIC_REGEX, '');
}

export function sanitizeNumber(text: string): string {
  return text.replace(NUMERIC_REGEX, '');
}
